// The server declares the mount. External URLs, fragments and query-only URLs keep their meaning.
export function getBasePath() {
  const value = document.querySelector('meta[name="app-base-path"]')?.content || '';
  if (value && !/^\/(?:[A-Za-z0-9_-]+\/)*[A-Za-z0-9_-]+$/.test(value)) throw new Error('Invalid application mount');
  return value;
}
const external = value => !value || /^(?:[a-z][a-z0-9+.-]*:|\/\/|#|\?)/i.test(value);
export function localUrl(value) {
  if (typeof value !== 'string' || external(value)) return value;
  const base = getBasePath();
  if (base && (value === base || value.startsWith(base + '/') || value.startsWith(base + '?'))) return value;
  return base + '/' + value.replace(/^\/+/, '');
}
export function assetUrl(value) {
  return typeof value !== 'string' || external(value) ? value : getBasePath() + '/' + value.replace(/^\/+/, '');
}
export function requestPath() {
  const base=getBasePath(), path=window.location.pathname;
  return base && (path===base || path.startsWith(base+'/')) ? path.slice(base.length)||'/' : path;
}
